"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = require("./container");
var executor_1 = require("./executor");
var react_1 = __importStar(require("react"));
var renderer_1 = require("./renderer");
function createModel(hook) {
    var container = new container_1.Container(hook);
    renderer_1.render(react_1.default.createElement(executor_1.Executor, { onUpdate: function (val) {
            container.data = val;
            container.notify();
        }, hook: hook }));
    var useModel = function (depsFn) {
        var _a = __read(react_1.useState(function () {
            return container ? container.data : undefined;
        }), 2), state = _a[0], setState = _a[1];
        var depsFnRef = react_1.useRef(depsFn);
        depsFnRef.current = depsFn;
        var depsRef = react_1.useRef([]);
        react_1.useEffect(function () {
            if (!container)
                return;
            function subscriber(val) {
                if (!depsFnRef.current) {
                    setState(val);
                }
                else {
                    var oldDeps = depsRef.current;
                    var newDeps = depsFnRef.current(val);
                    if (compare(oldDeps, newDeps)) {
                        setState(val);
                    }
                    depsRef.current = newDeps;
                }
            }
            container.subscribers.add(subscriber);
            return function () {
                container.subscribers.delete(subscriber);
            };
        }, [container]);
        return state;
    };
    Object.defineProperty(useModel, "data", {
        get: function () {
            return container.data;
        }
    });
    return useModel;
}
exports.createModel = createModel;
function compare(oldDeps, newDeps) {
    if (oldDeps.length !== newDeps.length) {
        return true;
    }
    for (var index in newDeps) {
        if (oldDeps[index] !== newDeps[index]) {
            return true;
        }
    }
    return false;
}
